export default __webpack_public_path__ + "static/media/icit.832bfe79.webp";